import { useCallback } from "react";

import { assertNever } from "../utils/assertNever";
import { useNoopMutation } from "./useGQLKeyInvalidator.generated";

export type GQLKeyInvalidator = () => Promise<void>;

/**
 * URQL doesn't allow access to the cache outside of a GraphQL operation.
 * We do this as a hack/workaround to manually invalidate document types.
 */
export function useGQLKeyInvalidator(objectTypeNamesToInvalidate: string | string[]): GQLKeyInvalidator {
    const [, mutateNoop] = useNoopMutation();

    return useCallback<GQLKeyInvalidator>(async () => {
        const additionalTypenames = Array.isArray(objectTypeNamesToInvalidate)
            ? objectTypeNamesToInvalidate
            : typeof objectTypeNamesToInvalidate === "string"
              ? [objectTypeNamesToInvalidate]
              : assertNever(objectTypeNamesToInvalidate);

        await mutateNoop({}, { additionalTypenames });
    }, [objectTypeNamesToInvalidate, mutateNoop]);
}
